import React, { useState, useEffect, Suspense } from "react";
import { CircularProgress, Grid } from "@material-ui/core";
import { getRoadmap } from "../requests";
import { challengeObject } from "../types";
import { Chip } from "@material-ui/core";
import { useStyles } from "../styles/roadmap";
import { Helmet } from "react-helmet";

const PageWelcomeCard = React.lazy(
  () => import("../components/PageWelcomeCard")
);
const ChallengesCard = React.lazy(() => import("../components/ChallengesCard"));
const RoadMapModal = React.lazy(() => import("../components/RoadMapModal"));
const Carousel = React.lazy(() => import("../components/Carousel"));

const obj = {
  title: "",
  description: "",
  solutions: [],
  tags: "",
  tagList: [],
};

export default function RoadMap() {
  const classes = useStyles();
  const [modalData, setModalData] = useState<challengeObject>(obj);
  const [toolkitData, setToolkitData] = useState<challengeObject[]>([]);
  const [colorList, setColorList] = useState<boolean[]>([]);
  const [tagList, setTagList] = useState<string[]>([]);
  const [activeTags, setActiveTags] = useState<string[]>([]);
  const [modalOpened, setModalOpened] = useState<boolean>(false);
  const [reset, setReset] = useState<boolean>(false);
  const [currentIndex,setCurrentIndex] = useState<number>(0);
  useEffect(() => {
    getRoadmap().then(async () => {
      const localData = localStorage.getItem("roadmapData");
      let tagsGlobal = [];
      if (localData) {
        const roadmapData: challengeObject[] = JSON.parse(localData || "{}");
        for (let i = 0; i < roadmapData.length; i++) {
          const tagsArr = roadmapData[i]["tags"].split(",");
          let resultArr = tagsArr.map((x: string) => {
            x = x.replace("'", "");
            x = x.replace("'", "");
            x = x.replace("[", "");
            x = x.replace("]", "");
            return x.trim();
          });
          roadmapData[i]["tagList"] = resultArr;
          for (let i = 0; i < resultArr.length; i++) {
            tagsGlobal.push(resultArr[i]);
          }
        }
        let uniqueItems = [...new Set(tagsGlobal)];
        uniqueItems = uniqueItems.filter((item) => {
          return item !== "";
        });
        setTagList(uniqueItems);
        setToolkitData(roadmapData);
      }
    });
  }, []);

  function search(items: challengeObject[]) {
    if (activeTags.length === 0) {
      return items;
    }
    return items.filter((item: challengeObject) => {
      return item.tagList.some((v) => activeTags.indexOf(v) !== -1);
    });
  }
  function hashCode(str: string) {
    // java String#hashCode
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }
  function intToRGB(i: number) {
    var c = (i & 0x00ffffff).toString(16).toUpperCase();

    return "00000".substring(0, 6 - c.length) + c;
  }

  const handleChallengeModal = (challengeData: challengeObject) => {
    setModalOpened(true);
    setModalData(challengeData);
    setCurrentIndex(toolkitData.indexOf(challengeData));
  };

  return (
    <div>
      <Helmet>
        <title>Toolkit</title>
        <meta
          name="Toolkit"
          content="A stepper flow of the challenges faced with their solutions and recommended actions"
        />
      </Helmet>

      {modalOpened ? (
        <Suspense fallback={<CircularProgress />}>
          <div style={{ paddingTop: "4em" }}>
            <Carousel
              data={toolkitData}
              setReset={setReset}
              handleChallengeModal={handleChallengeModal}
              index={currentIndex}
            />
            <RoadMapModal
              setReset={setReset}
              reset={reset}
              modalData={modalData}
              setModalOpened={setModalOpened}
            />
          </div>
        </Suspense>
      ) : (
        <>
          <Suspense fallback={<CircularProgress />}>
            <PageWelcomeCard
              title={"Select a challenge to begin"}
              description={"You can select tags to narrow down your search"}
            />
            <div className={classes.searchContainer}>
              <div className={classes.tagSelector}>
                {tagList.map((name, index) => {
                  return (
                    <div style={{ padding: "0.1em" }} key={index}>
                      <Chip
                        variant="outlined"
                        label={name}
                        onClick={() => {
                          if (colorList[index]) {
                            setColorList({ ...colorList, [index]: false });
                            setActiveTags(
                              activeTags.filter((item) => item !== name)
                            );
                          } else {
                            setActiveTags([...activeTags, name]);
                            setColorList({ ...colorList, [index]: true });
                          }
                        }}
                        className={classes.tag}
                        style={
                          colorList[index]
                            ? {
                                padding: "1.5em",
                                backgroundColor: "#" + intToRGB(hashCode(name)),
                                borderColor: "#" + intToRGB(hashCode(name)),
                                color: "white",
                              }
                            : {
                                padding: "1.5em",
                                color: "#" + intToRGB(hashCode(name)),
                                backgroundColor: "white",
                                borderColor: "#" + intToRGB(hashCode(name)),
                              }
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            <Grid
              container
              style={{
                maxWidth: "100%",
                padding: "2em",
                justifyContent: "center",
              }}
              spacing={1}
            >
              {search(toolkitData).map((challengeObj, index) => {
                return (
                  <Grid
                    item
                    xl={3}
                    lg={4}
                    md={6}
                    xs={12}
                    style={{
                      padding: "1em",
                      justifyContent: "center",
                      display: "flex",
                    }}
                    key={index}
                  >
                    <ChallengesCard
                      challengeData={challengeObj}
                      handleChallengeModal={handleChallengeModal}
                      index={index}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Suspense>
        </>
      )}
    </div>
  );
}
